import { child, onValue, ref, remove, set, update } from 'firebase/database';
import { useEffect, useState } from 'react';

import objectToArray from '../../utils/objectToArray';
import { database } from '../config';
import { ITask } from './typings';
import generateId from '../../utils/generateID';

const databaseRef = ref(database);

export const publicBoardsUrl = `boards`;

export const usePublicTasksByBoard = (id: string) => {
  const [tasks, setNewTask] = useState<ITask[]>([]);
  const [objects, setObject] = useState<Record<string, any>>({});
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    onValue(child(databaseRef, `${publicBoardsUrl}/${id}`), (snap) => {
      setNewTask(objectToArray(snap?.val()));
      setObject(snap?.val());
      setLoading(false);
    });
  }, []);

  return { tasks, loading, objects };
};

export const createBoard = async (name: string) => {
  try {
    const created = new Date().toISOString();
    const id = generateId();

    const data = {
      id,
      created,
      name,
    };

    await set(child(databaseRef, `${publicBoardsUrl}/${id}/`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const updateBoard = async (id: string, name: string) => {
  try {
    const data = {
      name,
    };

    await update(child(databaseRef, `${publicBoardsUrl}/${id}`), data);

    return data;
  } catch (e) {
    console.log(e);
    throw e;
  }
};

export const deleteBoard = async (id: string) => {
  try {
    await remove(child(databaseRef, `${publicBoardsUrl}/${id}`));
  } catch (e) {
    console.log(e);
    throw e;
  }
};
